import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { CV_FILE_SIZE, CV_SUPPORTED_FORMATS } from '../../../../constants/file';

export const validationSchema = (t: TFunction) =>
  Yup.object({
    firstname: Yup.string().required('Required'),
    lastname: Yup.string().required('Required'),
    phone: Yup.string().matches(
      /^\+[\d]{9,15}$/,
      'Phone number is not valid. Valid example: +33123456789',
    ),
    email: Yup.string().email('Invalid email'),
    linkedin: Yup.string().max(255, 'Must be 255 characters or less'),
    birthday: Yup.date().nullable(),
    address: Yup.string().max(255, 'Must be 255 characters or less'),
    addressSecondary: Yup.string().max(255, 'Must be 255 characters or less'),
    postalcode: Yup.string().max(255, 'Must be 255 characters or less'),
    city: Yup.string().max(255, 'Must be 255 characters or less'),
    country: Yup.string(),
    emailSecondary: Yup.string(),
    phoneProfessional: Yup.string(),
    cv: Yup.mixed()
      .test(
        'fileSize',
        t('validation.file_size'),
        (value) => value === undefined || (value && (value as File).size <= CV_FILE_SIZE),
      )
      .test(
        'fileFormat',
        t('validation.file_format'),
        (value) =>
          value === undefined || (value && CV_SUPPORTED_FORMATS.includes((value as File).type)),
      ),
    cv_fr: Yup.mixed()
      .test(
        'fileSize',
        t('validation.file_size'),
        (value) => value === undefined || (value && (value as File).size <= CV_FILE_SIZE),
      )
      .test(
        'fileFormat',
        t('validation.file_format'),
        (value) =>
          value === undefined || (value && CV_SUPPORTED_FORMATS.includes((value as File).type)),
      ),
  });
